<template>
  <div class="col-xl-7 col-lg-8">
    <div class="card card-body shadow text-left">
      <h1 class="h5 text-center">Ustvarite račun</h1>
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit(register)" novalidate>

          <ValidationProvider name="name" vid="emailToken._id" v-slot="{ errors }">
            <div v-if="errors[0]" class="alert alert-danger" role="alert">
              {{ errors[0] }}
            </div>
          </ValidationProvider>

          <div class="form-group">
            <ValidationProvider name="name" vid="name" rules="required" v-slot="{ errors }">
              <input type="text" class="form-control" v-model="host.name" name="name" placeholder="Ime in priimek" :class="{ 'is-invalid': errors[0] }">
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form-group">
            <ValidationProvider name="phone" vid="phone" rules="required" v-slot="{ errors }">
              <input type="text" class="form-control" v-model="host.phone" name="phone" placeholder="Telefonska številka" :class="{ 'is-invalid': errors[0] }">
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form-group">
            <ValidationProvider name="password" vid="password" rules="required|min:10" v-slot="{ errors }">
              <input type="password" class="form-control" v-model="host.password" name="password" placeholder="Geslo" :class="{ 'is-invalid': errors[0] }">
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
            <div><small>Geslo mora imeti vsaj 10 znakov</small></div>
          </div>
          <div class="form-group">
            <ValidationProvider name="terms &amp; conditions" vid="policies.terms" :rules="{ required: { allowFalse: false } }" v-slot="{ errors }">
              <div class="custom-control custom-checkbox text-small">
                <input v-model="host.policies.terms" type="checkbox" class="custom-control-input" :class="{ 'is-invalid': errors[0] }" id="sign-up-agree" v-bind:true-value="policies.terms.version">
                <label class="custom-control-label" for="sign-up-agree">
                  I agree to the
                  <router-link :to="{name: 'terms'}" target="_blank">Terms &amp; Conditions</router-link>
                </label>
              </div>
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <button class="btn btn-primary btn-block" type="submit">Ustvari račun</button>
        </form>
      </ValidationObserver>
    </div>
    <div class="text-center text-small mt-3">
      Že imate račun?
      <router-link to="/login" class="accent bold">Prijavite se tukaj</router-link>.
    </div>
  </div>
</template>

<script>

export default {
  name: 'RegisterInformation',
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  data: () => ({
    host: {
      name: '',
      phone: '',
      password: '',
      emailToken: {
        _id: null
      },
      'policies': {
        'terms': ''
      },
    },
    policies: {
      terms: {}
    }
  }),
  beforeCreate(){
    fetch( process.env.VUE_APP_API + '/policies?_id=terms', {
      method : 'get',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'CSRF-Token': this.$csrf
      }
    })
    .then(response => response.json())
    .then(response => {
      if(!response.error) this.policies.terms = response;
    });
  },
  methods: {
    register: function(){
      this.host.emailToken._id = this.$route.params.tokenId;
      if(!this.host.name) return this.error= "Name is required";
      if(!this.host.phone) return this.error = "Phone is required";
      if(!this.host.password) return this.error = "Password is required";
      fetch( process.env.VUE_APP_API + '/hosts?emailToken._id=' + this.$route.params.tokenId, {
        method : 'post',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'CSRF-Token': this.$csrf
        },
        body: JSON.stringify(this.host)
      })
      .then(response => response.json())
      .then(response => {
        console.log(response.error)
        if(response.error){
          this.$refs.form.setErrors(response.error.messages);
        }else{
          this.$parent.login({email: response.email, password: this.host.password})
          .then(response => {
            if(response.error){
              return this.errors = response.error.messages[0];
            }
            return location.href="/login";
          });
        }
      });
    }
  }
}
</script>
